import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModuleMenu } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';

@Component({
  selector: 'app-change-log',
  templateUrl: './change-log.component.html',
  styleUrls: ['./change-log.component.scss']
})
export class ChangeLogComponent implements OnInit {
  @Input() public Content: any;
  content: any;
  constructor(public modalRef: NgbActiveModal,
    public summaryService: IstSummaryService,
    private commonService: CommonService,
    private headService: HeadService) { }
  ChangeLog: any = [];
  ngOnInit(): void {
    this.getChangeLogData();
  }
  CancelClick() {
    this.modalRef.dismiss()
  }
  saveChangelogClick() {
      this.ChangeLog.forEach(element => {
        element.ApplicationID = this.Content.content.ApplicationID;
        element.ModuleID = this.Content.content.ModuleID;
        element.SubModuleID =this.Content.content.SubModuleID;
      });
      this.summaryService.saveChangeLog("api/ISTGeneralInfo/SaveApp_ChangeLog", this.ChangeLog).subscribe((result) => {
        this.modalRef.dismiss();
        this.commonService.refreshApplicationPage(this.Content.content.ApplicationID, this.Content.content.ModuleID,"");
      });
  }
  getChangeLogData() {
    this.summaryService.getAppSubmitValidations("api/ISTGeneralInfo/GetApp_ChangeLog?ApplicationID=" + this.Content.content.ApplicationID).subscribe((result) => {
      this.ChangeLog = result.Data;
    });
  }

}
